// extracted by mini-css-extract-plugin
export default {"addToCartControl":"i3-z","giftCard":"j3-z","btnContainer":"k3-z","cartButton":"l3-z","disabled":"m3-z"};